__turbopack_context__.v({
  "body-20": "bento-rectangle-module-scss-module__S-YguW__body-20",
  "body-20--lg": "bento-rectangle-module-scss-module__S-YguW__body-20--lg",
  "body-20--md": "bento-rectangle-module-scss-module__S-YguW__body-20--md",
  "body-20--sm": "bento-rectangle-module-scss-module__S-YguW__body-20--sm",
  "body-20--tablet": "bento-rectangle-module-scss-module__S-YguW__body-20--tablet",
  "body-20--xl": "bento-rectangle-module-scss-module__S-YguW__body-20--xl",
  "body-20--xs": "bento-rectangle-module-scss-module__S-YguW__body-20--xs",
  "body-20--xxs": "bento-rectangle-module-scss-module__S-YguW__body-20--xxs",
  "body-2xl": "bento-rectangle-module-scss-module__S-YguW__body-2xl",
  "body-2xl--lg": "bento-rectangle-module-scss-module__S-YguW__body-2xl--lg",
  "body-2xl--md": "bento-rectangle-module-scss-module__S-YguW__body-2xl--md",
  "body-2xl--sm": "bento-rectangle-module-scss-module__S-YguW__body-2xl--sm",
  "body-2xl--tablet": "bento-rectangle-module-scss-module__S-YguW__body-2xl--tablet",
  "body-2xl--xl": "bento-rectangle-module-scss-module__S-YguW__body-2xl--xl",
  "body-2xl--xs": "bento-rectangle-module-scss-module__S-YguW__body-2xl--xs",
  "body-2xl--xxs": "bento-rectangle-module-scss-module__S-YguW__body-2xl--xxs",
  "body-2xs": "bento-rectangle-module-scss-module__S-YguW__body-2xs",
  "body-2xs--lg": "bento-rectangle-module-scss-module__S-YguW__body-2xs--lg",
  "body-2xs--md": "bento-rectangle-module-scss-module__S-YguW__body-2xs--md",
  "body-2xs--sm": "bento-rectangle-module-scss-module__S-YguW__body-2xs--sm",
  "body-2xs--tablet": "bento-rectangle-module-scss-module__S-YguW__body-2xs--tablet",
  "body-2xs--xl": "bento-rectangle-module-scss-module__S-YguW__body-2xs--xl",
  "body-2xs--xs": "bento-rectangle-module-scss-module__S-YguW__body-2xs--xs",
  "body-2xs--xxs": "bento-rectangle-module-scss-module__S-YguW__body-2xs--xxs",
  "body-3xl": "bento-rectangle-module-scss-module__S-YguW__body-3xl",
  "body-3xl--lg": "bento-rectangle-module-scss-module__S-YguW__body-3xl--lg",
  "body-3xl--md": "bento-rectangle-module-scss-module__S-YguW__body-3xl--md",
  "body-3xl--sm": "bento-rectangle-module-scss-module__S-YguW__body-3xl--sm",
  "body-3xl--tablet": "bento-rectangle-module-scss-module__S-YguW__body-3xl--tablet",
  "body-3xl--xl": "bento-rectangle-module-scss-module__S-YguW__body-3xl--xl",
  "body-3xl--xs": "bento-rectangle-module-scss-module__S-YguW__body-3xl--xs",
  "body-3xl--xxs": "bento-rectangle-module-scss-module__S-YguW__body-3xl--xxs",
  "body-3xs": "bento-rectangle-module-scss-module__S-YguW__body-3xs",
  "body-3xs--lg": "bento-rectangle-module-scss-module__S-YguW__body-3xs--lg",
  "body-3xs--md": "bento-rectangle-module-scss-module__S-YguW__body-3xs--md",
  "body-3xs--sm": "bento-rectangle-module-scss-module__S-YguW__body-3xs--sm",
  "body-3xs--tablet": "bento-rectangle-module-scss-module__S-YguW__body-3xs--tablet",
  "body-3xs--xl": "bento-rectangle-module-scss-module__S-YguW__body-3xs--xl",
  "body-3xs--xs": "bento-rectangle-module-scss-module__S-YguW__body-3xs--xs",
  "body-3xs--xxs": "bento-rectangle-module-scss-module__S-YguW__body-3xs--xxs",
  "body-lg": "bento-rectangle-module-scss-module__S-YguW__body-lg",
  "body-lg--lg": "bento-rectangle-module-scss-module__S-YguW__body-lg--lg",
  "body-lg--md": "bento-rectangle-module-scss-module__S-YguW__body-lg--md",
  "body-lg--sm": "bento-rectangle-module-scss-module__S-YguW__body-lg--sm",
  "body-lg--tablet": "bento-rectangle-module-scss-module__S-YguW__body-lg--tablet",
  "body-lg--xl": "bento-rectangle-module-scss-module__S-YguW__body-lg--xl",
  "body-lg--xs": "bento-rectangle-module-scss-module__S-YguW__body-lg--xs",
  "body-lg--xxs": "bento-rectangle-module-scss-module__S-YguW__body-lg--xxs",
  "body-md": "bento-rectangle-module-scss-module__S-YguW__body-md",
  "body-md--lg": "bento-rectangle-module-scss-module__S-YguW__body-md--lg",
  "body-md--md": "bento-rectangle-module-scss-module__S-YguW__body-md--md",
  "body-md--sm": "bento-rectangle-module-scss-module__S-YguW__body-md--sm",
  "body-md--tablet": "bento-rectangle-module-scss-module__S-YguW__body-md--tablet",
  "body-md--xl": "bento-rectangle-module-scss-module__S-YguW__body-md--xl",
  "body-md--xs": "bento-rectangle-module-scss-module__S-YguW__body-md--xs",
  "body-md--xxs": "bento-rectangle-module-scss-module__S-YguW__body-md--xxs",
  "body-xl": "bento-rectangle-module-scss-module__S-YguW__body-xl",
  "body-xl--lg": "bento-rectangle-module-scss-module__S-YguW__body-xl--lg",
  "body-xl--md": "bento-rectangle-module-scss-module__S-YguW__body-xl--md",
  "body-xl--sm": "bento-rectangle-module-scss-module__S-YguW__body-xl--sm",
  "body-xl--tablet": "bento-rectangle-module-scss-module__S-YguW__body-xl--tablet",
  "body-xl--xl": "bento-rectangle-module-scss-module__S-YguW__body-xl--xl",
  "body-xl--xs": "bento-rectangle-module-scss-module__S-YguW__body-xl--xs",
  "body-xl--xxs": "bento-rectangle-module-scss-module__S-YguW__body-xl--xxs",
  "body-xs": "bento-rectangle-module-scss-module__S-YguW__body-xs",
  "body-xs--lg": "bento-rectangle-module-scss-module__S-YguW__body-xs--lg",
  "body-xs--md": "bento-rectangle-module-scss-module__S-YguW__body-xs--md",
  "body-xs--sm": "bento-rectangle-module-scss-module__S-YguW__body-xs--sm",
  "body-xs--tablet": "bento-rectangle-module-scss-module__S-YguW__body-xs--tablet",
  "body-xs--xl": "bento-rectangle-module-scss-module__S-YguW__body-xs--xl",
  "body-xs--xs": "bento-rectangle-module-scss-module__S-YguW__body-xs--xs",
  "body-xs--xxs": "bento-rectangle-module-scss-module__S-YguW__body-xs--xxs",
  "boxOne": "bento-rectangle-module-scss-module__S-YguW__boxOne",
  "boxOneContent": "bento-rectangle-module-scss-module__S-YguW__boxOneContent",
  "boxOneCopy": "bento-rectangle-module-scss-module__S-YguW__boxOneCopy",
  "buttons": "bento-rectangle-module-scss-module__S-YguW__buttons",
  "center": "bento-rectangle-module-scss-module__S-YguW__center",
  "heading": "bento-rectangle-module-scss-module__S-YguW__heading",
  "heading-120": "bento-rectangle-module-scss-module__S-YguW__heading-120",
  "heading-120--lg": "bento-rectangle-module-scss-module__S-YguW__heading-120--lg",
  "heading-120--md": "bento-rectangle-module-scss-module__S-YguW__heading-120--md",
  "heading-120--sm": "bento-rectangle-module-scss-module__S-YguW__heading-120--sm",
  "heading-120--tablet": "bento-rectangle-module-scss-module__S-YguW__heading-120--tablet",
  "heading-120--xl": "bento-rectangle-module-scss-module__S-YguW__heading-120--xl",
  "heading-120--xs": "bento-rectangle-module-scss-module__S-YguW__heading-120--xs",
  "heading-120--xxs": "bento-rectangle-module-scss-module__S-YguW__heading-120--xxs",
  "heading-128": "bento-rectangle-module-scss-module__S-YguW__heading-128",
  "heading-128--lg": "bento-rectangle-module-scss-module__S-YguW__heading-128--lg",
  "heading-128--md": "bento-rectangle-module-scss-module__S-YguW__heading-128--md",
  "heading-128--sm": "bento-rectangle-module-scss-module__S-YguW__heading-128--sm",
  "heading-128--tablet": "bento-rectangle-module-scss-module__S-YguW__heading-128--tablet",
  "heading-128--xl": "bento-rectangle-module-scss-module__S-YguW__heading-128--xl",
  "heading-128--xs": "bento-rectangle-module-scss-module__S-YguW__heading-128--xs",
  "heading-128--xxs": "bento-rectangle-module-scss-module__S-YguW__heading-128--xxs",
  "heading-150": "bento-rectangle-module-scss-module__S-YguW__heading-150",
  "heading-150--lg": "bento-rectangle-module-scss-module__S-YguW__heading-150--lg",
  "heading-150--md": "bento-rectangle-module-scss-module__S-YguW__heading-150--md",
  "heading-150--sm": "bento-rectangle-module-scss-module__S-YguW__heading-150--sm",
  "heading-150--tablet": "bento-rectangle-module-scss-module__S-YguW__heading-150--tablet",
  "heading-150--xl": "bento-rectangle-module-scss-module__S-YguW__heading-150--xl",
  "heading-150--xs": "bento-rectangle-module-scss-module__S-YguW__heading-150--xs",
  "heading-150--xxs": "bento-rectangle-module-scss-module__S-YguW__heading-150--xxs",
  "heading-2xl": "bento-rectangle-module-scss-module__S-YguW__heading-2xl",
  "heading-2xl--lg": "bento-rectangle-module-scss-module__S-YguW__heading-2xl--lg",
  "heading-2xl--md": "bento-rectangle-module-scss-module__S-YguW__heading-2xl--md",
  "heading-2xl--sm": "bento-rectangle-module-scss-module__S-YguW__heading-2xl--sm",
  "heading-2xl--tablet": "bento-rectangle-module-scss-module__S-YguW__heading-2xl--tablet",
  "heading-2xl--xl": "bento-rectangle-module-scss-module__S-YguW__heading-2xl--xl",
  "heading-2xl--xs": "bento-rectangle-module-scss-module__S-YguW__heading-2xl--xs",
  "heading-2xl--xxs": "bento-rectangle-module-scss-module__S-YguW__heading-2xl--xxs",
  "heading-3xl": "bento-rectangle-module-scss-module__S-YguW__heading-3xl",
  "heading-3xl--lg": "bento-rectangle-module-scss-module__S-YguW__heading-3xl--lg",
  "heading-3xl--md": "bento-rectangle-module-scss-module__S-YguW__heading-3xl--md",
  "heading-3xl--sm": "bento-rectangle-module-scss-module__S-YguW__heading-3xl--sm",
  "heading-3xl--tablet": "bento-rectangle-module-scss-module__S-YguW__heading-3xl--tablet",
  "heading-3xl--xl": "bento-rectangle-module-scss-module__S-YguW__heading-3xl--xl",
  "heading-3xl--xs": "bento-rectangle-module-scss-module__S-YguW__heading-3xl--xs",
  "heading-3xl--xxs": "bento-rectangle-module-scss-module__S-YguW__heading-3xl--xxs",
  "heading-4xl": "bento-rectangle-module-scss-module__S-YguW__heading-4xl",
  "heading-4xl--lg": "bento-rectangle-module-scss-module__S-YguW__heading-4xl--lg",
  "heading-4xl--md": "bento-rectangle-module-scss-module__S-YguW__heading-4xl--md",
  "heading-4xl--sm": "bento-rectangle-module-scss-module__S-YguW__heading-4xl--sm",
  "heading-4xl--tablet": "bento-rectangle-module-scss-module__S-YguW__heading-4xl--tablet",
  "heading-4xl--xl": "bento-rectangle-module-scss-module__S-YguW__heading-4xl--xl",
  "heading-4xl--xs": "bento-rectangle-module-scss-module__S-YguW__heading-4xl--xs",
  "heading-4xl--xxs": "bento-rectangle-module-scss-module__S-YguW__heading-4xl--xxs",
  "heading-5xl": "bento-rectangle-module-scss-module__S-YguW__heading-5xl",
  "heading-5xl--lg": "bento-rectangle-module-scss-module__S-YguW__heading-5xl--lg",
  "heading-5xl--md": "bento-rectangle-module-scss-module__S-YguW__heading-5xl--md",
  "heading-5xl--sm": "bento-rectangle-module-scss-module__S-YguW__heading-5xl--sm",
  "heading-5xl--tablet": "bento-rectangle-module-scss-module__S-YguW__heading-5xl--tablet",
  "heading-5xl--xl": "bento-rectangle-module-scss-module__S-YguW__heading-5xl--xl",
  "heading-5xl--xs": "bento-rectangle-module-scss-module__S-YguW__heading-5xl--xs",
  "heading-5xl--xxs": "bento-rectangle-module-scss-module__S-YguW__heading-5xl--xxs",
  "heading-60": "bento-rectangle-module-scss-module__S-YguW__heading-60",
  "heading-60--lg": "bento-rectangle-module-scss-module__S-YguW__heading-60--lg",
  "heading-60--md": "bento-rectangle-module-scss-module__S-YguW__heading-60--md",
  "heading-60--sm": "bento-rectangle-module-scss-module__S-YguW__heading-60--sm",
  "heading-60--tablet": "bento-rectangle-module-scss-module__S-YguW__heading-60--tablet",
  "heading-60--xl": "bento-rectangle-module-scss-module__S-YguW__heading-60--xl",
  "heading-60--xs": "bento-rectangle-module-scss-module__S-YguW__heading-60--xs",
  "heading-60--xxs": "bento-rectangle-module-scss-module__S-YguW__heading-60--xxs",
  "heading-70": "bento-rectangle-module-scss-module__S-YguW__heading-70",
  "heading-70--lg": "bento-rectangle-module-scss-module__S-YguW__heading-70--lg",
  "heading-70--md": "bento-rectangle-module-scss-module__S-YguW__heading-70--md",
  "heading-70--sm": "bento-rectangle-module-scss-module__S-YguW__heading-70--sm",
  "heading-70--tablet": "bento-rectangle-module-scss-module__S-YguW__heading-70--tablet",
  "heading-70--xl": "bento-rectangle-module-scss-module__S-YguW__heading-70--xl",
  "heading-70--xs": "bento-rectangle-module-scss-module__S-YguW__heading-70--xs",
  "heading-70--xxs": "bento-rectangle-module-scss-module__S-YguW__heading-70--xxs",
  "heading-90": "bento-rectangle-module-scss-module__S-YguW__heading-90",
  "heading-90--lg": "bento-rectangle-module-scss-module__S-YguW__heading-90--lg",
  "heading-90--md": "bento-rectangle-module-scss-module__S-YguW__heading-90--md",
  "heading-90--sm": "bento-rectangle-module-scss-module__S-YguW__heading-90--sm",
  "heading-90--tablet": "bento-rectangle-module-scss-module__S-YguW__heading-90--tablet",
  "heading-90--xl": "bento-rectangle-module-scss-module__S-YguW__heading-90--xl",
  "heading-90--xs": "bento-rectangle-module-scss-module__S-YguW__heading-90--xs",
  "heading-90--xxs": "bento-rectangle-module-scss-module__S-YguW__heading-90--xxs",
  "heading-lg": "bento-rectangle-module-scss-module__S-YguW__heading-lg",
  "heading-lg--lg": "bento-rectangle-module-scss-module__S-YguW__heading-lg--lg",
  "heading-lg--md": "bento-rectangle-module-scss-module__S-YguW__heading-lg--md",
  "heading-lg--sm": "bento-rectangle-module-scss-module__S-YguW__heading-lg--sm",
  "heading-lg--tablet": "bento-rectangle-module-scss-module__S-YguW__heading-lg--tablet",
  "heading-lg--xl": "bento-rectangle-module-scss-module__S-YguW__heading-lg--xl",
  "heading-lg--xs": "bento-rectangle-module-scss-module__S-YguW__heading-lg--xs",
  "heading-lg--xxs": "bento-rectangle-module-scss-module__S-YguW__heading-lg--xxs",
  "heading-md": "bento-rectangle-module-scss-module__S-YguW__heading-md",
  "heading-md--lg": "bento-rectangle-module-scss-module__S-YguW__heading-md--lg",
  "heading-md--md": "bento-rectangle-module-scss-module__S-YguW__heading-md--md",
  "heading-md--sm": "bento-rectangle-module-scss-module__S-YguW__heading-md--sm",
  "heading-md--tablet": "bento-rectangle-module-scss-module__S-YguW__heading-md--tablet",
  "heading-md--xl": "bento-rectangle-module-scss-module__S-YguW__heading-md--xl",
  "heading-md--xs": "bento-rectangle-module-scss-module__S-YguW__heading-md--xs",
  "heading-md--xxs": "bento-rectangle-module-scss-module__S-YguW__heading-md--xxs",
  "heading-sm": "bento-rectangle-module-scss-module__S-YguW__heading-sm",
  "heading-sm--lg": "bento-rectangle-module-scss-module__S-YguW__heading-sm--lg",
  "heading-sm--md": "bento-rectangle-module-scss-module__S-YguW__heading-sm--md",
  "heading-sm--sm": "bento-rectangle-module-scss-module__S-YguW__heading-sm--sm",
  "heading-sm--tablet": "bento-rectangle-module-scss-module__S-YguW__heading-sm--tablet",
  "heading-sm--xl": "bento-rectangle-module-scss-module__S-YguW__heading-sm--xl",
  "heading-sm--xs": "bento-rectangle-module-scss-module__S-YguW__heading-sm--xs",
  "heading-sm--xxs": "bento-rectangle-module-scss-module__S-YguW__heading-sm--xxs",
  "heading-xl": "bento-rectangle-module-scss-module__S-YguW__heading-xl",
  "heading-xl--lg": "bento-rectangle-module-scss-module__S-YguW__heading-xl--lg",
  "heading-xl--md": "bento-rectangle-module-scss-module__S-YguW__heading-xl--md",
  "heading-xl--sm": "bento-rectangle-module-scss-module__S-YguW__heading-xl--sm",
  "heading-xl--tablet": "bento-rectangle-module-scss-module__S-YguW__heading-xl--tablet",
  "heading-xl--xl": "bento-rectangle-module-scss-module__S-YguW__heading-xl--xl",
  "heading-xl--xs": "bento-rectangle-module-scss-module__S-YguW__heading-xl--xs",
  "heading-xl--xxs": "bento-rectangle-module-scss-module__S-YguW__heading-xl--xxs",
  "heading-xs": "bento-rectangle-module-scss-module__S-YguW__heading-xs",
  "heading-xs--lg": "bento-rectangle-module-scss-module__S-YguW__heading-xs--lg",
  "heading-xs--md": "bento-rectangle-module-scss-module__S-YguW__heading-xs--md",
  "heading-xs--sm": "bento-rectangle-module-scss-module__S-YguW__heading-xs--sm",
  "heading-xs--tablet": "bento-rectangle-module-scss-module__S-YguW__heading-xs--tablet",
  "heading-xs--xl": "bento-rectangle-module-scss-module__S-YguW__heading-xs--xl",
  "heading-xs--xs": "bento-rectangle-module-scss-module__S-YguW__heading-xs--xs",
  "heading-xs--xxs": "bento-rectangle-module-scss-module__S-YguW__heading-xs--xxs",
  "heading-xxs": "bento-rectangle-module-scss-module__S-YguW__heading-xxs",
  "heading-xxs--lg": "bento-rectangle-module-scss-module__S-YguW__heading-xxs--lg",
  "heading-xxs--md": "bento-rectangle-module-scss-module__S-YguW__heading-xxs--md",
  "heading-xxs--sm": "bento-rectangle-module-scss-module__S-YguW__heading-xxs--sm",
  "heading-xxs--tablet": "bento-rectangle-module-scss-module__S-YguW__heading-xxs--tablet",
  "heading-xxs--xl": "bento-rectangle-module-scss-module__S-YguW__heading-xxs--xl",
  "heading-xxs--xs": "bento-rectangle-module-scss-module__S-YguW__heading-xxs--xs",
  "heading-xxs--xxs": "bento-rectangle-module-scss-module__S-YguW__heading-xxs--xxs",
  "headingImage": "bento-rectangle-module-scss-module__S-YguW__headingImage",
  "headinggradient": "bento-rectangle-module-scss-module__S-YguW__headinggradient",
  "iconTextList": "bento-rectangle-module-scss-module__S-YguW__iconTextList",
  "iconTextListContainer": "bento-rectangle-module-scss-module__S-YguW__iconTextListContainer",
  "image": "bento-rectangle-module-scss-module__S-YguW__image",
  "imageContainer": "bento-rectangle-module-scss-module__S-YguW__imageContainer",
  "invertLayout": "bento-rectangle-module-scss-module__S-YguW__invertLayout",
  "large-prompt": "bento-rectangle-module-scss-module__S-YguW__large-prompt",
  "large-prompt--lg": "bento-rectangle-module-scss-module__S-YguW__large-prompt--lg",
  "large-prompt--md": "bento-rectangle-module-scss-module__S-YguW__large-prompt--md",
  "large-prompt--sm": "bento-rectangle-module-scss-module__S-YguW__large-prompt--sm",
  "large-prompt--tablet": "bento-rectangle-module-scss-module__S-YguW__large-prompt--tablet",
  "large-prompt--xl": "bento-rectangle-module-scss-module__S-YguW__large-prompt--xl",
  "large-prompt--xs": "bento-rectangle-module-scss-module__S-YguW__large-prompt--xs",
  "large-prompt--xxs": "bento-rectangle-module-scss-module__S-YguW__large-prompt--xxs",
  "left": "bento-rectangle-module-scss-module__S-YguW__left",
  "media": "bento-rectangle-module-scss-module__S-YguW__media",
  "right": "bento-rectangle-module-scss-module__S-YguW__right",
  "subtitle": "bento-rectangle-module-scss-module__S-YguW__subtitle",
  "vertical": "bento-rectangle-module-scss-module__S-YguW__vertical",
  "winnersBadge": "bento-rectangle-module-scss-module__S-YguW__winnersBadge",
});
